import React from 'react'
import CommonTable from '../../../../drive/Table/TableLayout';
import UserTeamsListView from './UserTeamsListViewJSON.json'
import DeleteUserFromUnit from './../modals/DeleteUserFromUnit';
import { dispatch } from '@rematch/core';

class UserTeamsList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tableHeader: UserTeamsListView,
            listData: this.props.userSuborganizationList,
            _limit: 10,
            _sort: "name"
        };
    }

    addColumn = (newColumns) => {
        if (newColumns) {
            this.setState({ tableHeader: newColumns })
        }
    };
    handleTableComponent = (event, item, data) => {

    }
    handleDropDownItem = (event, type, data) => {
        if (type.text === "Details") {
            this.handleClickTeamDetailsPage(event, data)
        }
        if (type.text === "Delete") {
            this.deleteUserInTeam(event, data)
        }
    }
    async handleClickTeamDetailsPage(event, data) {
        event.stopPropagation();
        await dispatch.users.storeUnitId(data.subOrgId);
        await dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        await dispatch.organizationUnit.showResourecePane(null);
        await dispatch.organizationUnit.getSubOrgByIdAsync(data.subOrgId);
        this.props.history.push({
            pathname: `/app/${this.props.selectedAccount._id}/_ws/${this.props.selectedOrganisation.id}/_cm/teamDetail/${data.subOrgId}`,
        });
    }
    deleteUserInTeam(event, data) {
        let deletesuborgObj = Object.assign({}, this.props.userObj);
        deletesuborgObj.role = data.role;
        deletesuborgObj.subOrgName = data.subOrgName;
        deletesuborgObj.subOrgId = data.subOrgId;
        deletesuborgObj.type = 'userTeamsListView';
        deletesuborgObj.organisation = data.subOrgName;
        dispatch.users.addUserToDelete(deletesuborgObj);
        dispatch.users.userDelModalOpen(true);
    }

    render() {
        for (let i = 0; i < this.state.listData.length; i++) {
            if (this.state.listData[i].managersCount < 2 && this.state.listData[i].role === 'Manager') {
                this.state.listData[i].isDisbledDelete = true;
            }
            else {
                this.state.listData[i].isDisbledDelete = false;
            }

        }
        return (
            <div>
                <CommonTable
                    tableHeader={this.state.tableHeader}
                    listData={this.state.listData}
                    searchable={false}
                    selection={true}
                    limit={this.state._limit}
                    sort={this.state._sort}
                    totalCount={this.state.listData.length}
                    loading={this.props.worspacesLoading}
                    addColumn={this.addColumn}
                    handleDropDownItem={this.handleDropDownItem}
                    handleTableComponent={this.handleTableComponent}
                />

                {this.props.userDelModalOpen ?
                    <DeleteUserFromUnit
                        selectedOrganisation={this.props.selectedOrganisation}
                        selectedAccount={this.props.selectedAccount}
                        userToDel={this.props.userToDel}
                        selectedTeamName={this.props.userToDel.subOrgName}
                        userDelModalOpen={this.props.userDelModalOpen}
                        userObj={this.props.userObj}
                        userSuborganizationList={this.props.userSuborganizationList}
                    />
                    : ''}
            </div>
        )
    }
}

export default UserTeamsList;
